import React, { useState,useRef, useEffect  } from 'react';
import { Link } from 'react-router-dom'
import { Modal,Box, List,ListItem,ListItemText,Typography,Divider,Stack,Pagination,TextField,Tooltip,Menu} from '@mui/material';
import {  Document, Page,pdfjs } from 'react-pdf';
import { PdfViewer } from "react-pdf-selection";
import pdfview from '../../src/assets/images/Company-Overview.pdf';
import ContentLoader from './loader/content-loader';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import ExpandLessOutlinedIcon from '@mui/icons-material/ExpandLessOutlined';
import ExpandMoreOutlinedIcon from '@mui/icons-material/ExpandMoreOutlined';
import { motion } from 'framer-motion';
import { Worker, Viewer, SpecialZoomLevel  } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import { pageNavigationPlugin } from '@react-pdf-viewer/page-navigation';
import { searchPlugin } from '@react-pdf-viewer/search';

// Import styles
import '@react-pdf-viewer/search/lib/styles/index.css';
import '@react-pdf-viewer/selection-mode/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import PageLoader from './page-loader';
// pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export default function OCRPdf(props) {

const defaultLayoutPluginInstance = defaultLayoutPlugin();
const pageNavigationPluginInstance = pageNavigationPlugin();
const searchPluginInstance = searchPlugin();

const [numPages, setNumPages] = useState();
const [pageNumber, setPageNumber] = useState(1);
const [inputPageNumber, setInputPageNumber] = useState(1);
const [isProgrammaticScroll, setIsProgrammaticScroll] = useState(true);
const [pageDimesnisons, setPageDimesnisons] = useState({});
const pdfContainerRef = useRef(null);
const onDocumentLoadSuccess = ({ numPages }) => {
setNumPages(numPages);
};

   

      const [anchorEl3, setAnchorEl3] = useState(null);
      const open3 = Boolean(anchorEl3);
      const handleClick3 = (event) => {
      setAnchorEl3(event.currentTarget);
      };
      const handleClose3 = () => {
      setAnchorEl3(null);
      };

      const [activePdf, setActivePdf] = useState(props?.chunks[0]?.metadata.knowledge_id);
      const [pdfLoader, setPdfLoader] = useState(false);


      const handleChunkClick =(chunk) => {
         
         if(activePdf === chunk.metadata.knowledge_id){
            pageNavigationPluginInstance.jumpToPage(chunk.metadata.page_number-1);
         }
         else{
            props.getSignedPdf(chunk.metadata.knowledge_id, "chunk")
            setActivePdf(chunk.metadata.knowledge_id)
             
            setTimeout(() => {
               pageNavigationPluginInstance.jumpToPage(chunk.metadata.page_number-1);
            }, 3000);
         }
         // setMoveToPage(chunk.metadata.page_number)
      }

      useEffect(() => {
         if(props?.pdf)
         {
            setPdfLoader(false)
         }
         else{
            setPdfLoader(true);
         }
      },[props?.pdf])

      useEffect(() => {
         if(activePdf){
            props.getSignedPdf(activePdf, "chunk")
         }
      }, [activePdf]);

return (
<>
<Modal
   open={props.openocrpdf}
   onClose={props.handleCloseocrpdf} 
   aria-labelledby="modal-modal-title"
   aria-describedby="modal-modal-description"
   >
   <Box className=" commonpopup  modal-common popup-w85 "  >
  
         <div className="card-item__content   ">
            <div class="card-title">
               <h2>Source PDF  data</h2>
               <span>Lorem Ipsum is simply dummy text of the printing and typesetting industry.   </span>
            </div>
            <Link  className="close" onClick={props.handleCloseocrpdf}>
            X</Link>
         </div>
         <div className="modal-body">
         <div className="popup_scroller">
         <div className='match_pdf_wrapper'>
            <div className='match_pdf_body'>
               <div className='match_content_flex'>
                  <div className='match_content'>
                     <div className='match_conten_body'>
                        <div className='match_content_list'>
                           <div className="readable_content source_data_pdf">
                              <List sx={{ width: '100%',   backgroundColor:'#fafafa' }}>
                              {props?.chunks &&
                               props?.chunks.length > 0 &&
                               props?.chunks.map((chunk, index) => {
                                 return(<ListItem alignItems="flex-start" key={index} onClick={() => {handleChunkClick(chunk)}}>
                                 <div className='pdf_source_head'>
                                    <div className='pdf_source_title'>
                                       <h2>{chunk.metadata.file_name ? chunk.metadata.file_name : "NA"}</h2>
                                    </div>
                                    <div className='source_pagenumber'>
                                    <span> Page </span> 
                                    <span>-</span>
                                       <Link to="#" className='pagenumcircle'>
                                       {chunk.metadata.page_number ? chunk.metadata.page_number : "NA"}</Link>  
                                    </div>
                                 </div>
                                 <ListItemText primary={chunk.page_content ? chunk.page_content : "NA"} />
                              </ListItem>)
                               })}                             
                              </List>
                           </div>
                        </div>
                     </div>
                  </div>
                  
                   <div className='match_conten_pdf'>
                   {pdfLoader && 
                  <div style={{minHeight: "calc(100vh - 350px)"}}>
                  <ContentLoader />
                  </div>
                  }
                   {props?.pdf && pdfLoader === false &&
                     <div className='right_chat_content_fix'>

                        <div className='pdfView_wrapper'>
                        <div className='pdfView_head'>
         <div className='pdf_title'  >
 
            <h2  >{props?.pdf?.file_name ? props?.pdf?.file_name : "NA"}</h2>
         </div>
      </div>
                           <div className='pdfView_body'>                           
                           <div className="match_PDF_scroller">
                            <></>                            
                             <Worker
                              workerUrl={`//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`}
                            >
                              <Viewer
                                fileUrl={props?.pdf?.file_path}
                                defaultScale={SpecialZoomLevel.PageFit}
                                plugins={[
                                  defaultLayoutPluginInstance,
                                  pageNavigationPluginInstance,
                                  searchPluginInstance,
                             ]}
                           />
                         </Worker>
                       </div>
                           </div>
                        </div>
                     </div>}
                  </div>
               </div>
            </div>
         </div>
         </div>
      </div>
   </Box>
</Modal>
</>
)
}